var map = {
	"./amandeep.png": 1479,
	"./carole.png": 8842,
	"./chris.png": 841,
	"./claire.png": 9410,
	"./david.png": 8550,
	"./donald.png": 6174,
	"./hannah.png": 7547,
	"./meg.png": 8437,
	"./mel.png": 8470,
	"./richard.png": 121,
	"./sarah.png": 7329,
	"./seb.jpg": 4798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8435;